import { actions } from './order/actions'
import { getters } from './order/getters'
import { state } from './order/state'
import { mutations } from './order/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
